var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 11.334L8.0026 14.0007L10.6693 11.334",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8V14",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9195 12.06C14.4991 11.6524 14.9337 11.0707 15.1603 10.3994C15.3869 9.72805 15.3937 9.00197 15.1797 8.32651C14.9657 7.65104 14.542 7.06135 13.9702 6.643C13.3983 6.22464 12.708 5.9994 11.9995 5.99996H11.1595C10.959 5.21854 10.5838 4.49279 10.0622 3.87734C9.54063 3.2619 8.88623 2.7728 8.14827 2.44686C7.41031 2.12092 6.60803 1.96664 5.80182 1.99563C4.99561 2.02463 4.20648 2.23614 3.49384 2.61424C2.7812 2.99234 2.16362 3.52719 1.68759 4.17851C1.21157 4.82983 0.889502 5.58065 0.745641 6.37446C0.60178 7.16826 0.639874 7.98435 0.857054 8.7613C1.07423 9.53825 1.46484 10.2558 1.99947 10.86",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_2458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadBlack);
export default __webpack_public_path__ + "static/media/cloud-download-black.054873ae1e416adcadebfd004a4deebc.svg";
export { ForwardRef as ReactComponent };